<template>
  <div>
    <Navbar activeDirectory="profile" activePage="change-password"></Navbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <div class="alert alert-warning" v-if="error_msg">
                {{ error_msg }}
              </div>
              <div class="alert alert-success" v-if="success_msg">
                {{ success_msg }}
              </div>
              <div class="form-group">
                <label class="pull-left">Password Attuale</label>
                <input type="password" v-model="old_pwd" class="form-control" placeholder="Password Attuale">
              </div>
              <div class="form-group">
                <label class="pull-left">Nuova Password</label>
                <input type="password" v-model="new_pwd" class="form-control" placeholder="Nuova Password">
              </div>
              <div class="form-group">
                <label class="pull-left">Conferma Password</label>
                <input type="password" v-model="cfn_pwd" class="form-control" placeholder="Conferma Password">
              </div>

              <button class="btn btn-success pull-right btn-sm" @click="updatePwd()">Aggiorna Informazioni</button>
            </div>
          </div>          
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";

export default {
  components: {
    Navbar
  },

  data () {
    return {
      old_pwd: undefined,
      new_pwd: undefined,
      cfn_pwd: undefined,
      error_msg: undefined,
      success_msg: undefined,
    }
  },

  methods: {
    /** 
     * updatePwd
     * 
     * Update user password
     * 
     * 2020-08-25 [fmarigliano@bidata.it] - Method creation
     */
    updatePwd() {
      if ( this.cfn_pwd != this.new_pwd ) {
        this.error_msg = 'La nuova password non corrisponde a quella di conferma'
      } else {
        var formData = new FormData()
        formData.append('old_psw', this.old_pwd)
        formData.append('new_psw', this.new_pwd)
        this.axios.post("/change-password", formData).then(response=>{
          if(response.data['success']){
            this.error_msg = undefined
            this.success_msg = 'Password modificata con successo'
          } else {
            this.error_msg = response.data['error']
          }
        })
      }
    }
  }

}
</script>

<style>

</style>